import { useStore } from "../../stores/StoreContext";
import { ImageGenerationService } from "../LogicServices/ImageGenerationService";

export function useImageGenerationService(): ImageGenerationService {
  const storeContext = useStore();
  return new ImageGenerationService(storeContext);
}
